// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token"); // Check if the token exists

  return token ? children : <Navigate to="/login" />; // If token exists, render children; otherwise, redirect to login
};

export default ProtectedRoute;
